import { labeled, boolean, stringRequired, custom } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  custom(Joi)
    .object()
    .keys({
      accessPrepaidFunds: boolean(Joi).label(
        labeled(label, 'Flexibility to access prepaid funds if needed)')
      ),
      other: boolean(Joi).label(labeled(label, 'Other'))
    })
    .orValue('accessPrepaidFunds', 'other')
    .label(label)
    .when('.other', {
      is: true,
      then: Joi.object({
        otherComments: stringRequired(Joi, 1, 4096).label(labeled(label, 'Details'))
      })
    });

export default {
  schema
};
